import CustomCode from './CustomCode';
import Enquiry from './Enquiry';
import Home from './Home';
import Logout from './Logout';
import ShortUrl from './ShortUrl';
import Staff from './Staff';
import StaffLogin from './StaffLogin';

const Pages = {
  CustomCode,
  Home,
  Logout,
  ShortUrl,
  Staff,
  StaffLogin,
  Enquiry,
};

export default Pages;
